var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCheckCircle24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.24 20.2133L26.6667 37.7866L17.0934 28.2399L13.3334 31.9999L26.6667 45.3333L48 23.9999L44.24 20.2133ZM32 5.33325C17.28 5.33325 5.33337 17.2799 5.33337 31.9999C5.33337 46.7199 17.28 58.6666 32 58.6666C46.72 58.6666 58.6667 46.7199 58.6667 31.9999C58.6667 17.2799 46.72 5.33325 32 5.33325ZM32 53.3333C20.2134 53.3333 10.6667 43.7866 10.6667 31.9999C10.6667 20.2133 20.2134 10.6666 32 10.6666C43.7867 10.6666 53.3334 20.2133 53.3334 31.9999C53.3334 43.7866 43.7867 53.3333 32 53.3333Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 13.1439,
    y1: 50.8561,
    x2: 50.8562,
    y2: 13.1437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0033AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0033AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckCircle24Px);
export default __webpack_public_path__ + "static/media/ic_check-circle_24px.c50a112f839f8cd69db09f9028a30ad6.svg";
export { ForwardRef as ReactComponent };